import * as Yup from "yup";
export const MediaSchema = Yup.object({
    MEDIA_URL: Yup.string().required(),
});
export function getMediaConfig(env) {
    return {
        MEDIA_URL: env.REACT_APP_MEDIA_URL,
    };
}
//# sourceMappingURL=media.js.map